import React from 'react';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Typography from '@src/new-components/Typography';
import CommonButton from '@src/new-components/Button';
import { COLOR } from '@src/styles/color';
import { ArrowBack } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import UpdateAppActiveStatus from './UpdateAppActiveStatus';
import { StyledListAppDetailHeader } from './index.style';

const Header = ({
  active,
  onUpdateAppStatus,
  actionLoading,
  openUpdateAppStatus,
  onOpenUpdateAppStatus,
  onCloseUpdateAppStatus,
}) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleClick = () => {
    window.history.back();
  };
  return (
    <StyledListAppDetailHeader>
      <div className="header-title">
        {!isMobile ? (
          <CommonButton
            variant="outlineSmall"
            onClick={handleClick}
            customStyle={{
              width: '40px',
              height: '40px',
              minWidth: '40px',
            }}
          >
            <ArrowBack />
          </CommonButton>
        ) : (
          <ArrowBack onClick={handleClick} sx={{ color: COLOR.navyBlue }} />
        )}

        <Typography
          className="app-detail-header-text"
          variant="body-20-bold"
          color={COLOR.label2[100]}
        >
          {t('detailsApp')}
        </Typography>
      </div>
      <UpdateAppActiveStatus
        active={active}
        onUpdateAppStatus={onUpdateAppStatus}
        actionLoading={actionLoading}
        open={openUpdateAppStatus}
        onOpen={onOpenUpdateAppStatus}
        onClose={onCloseUpdateAppStatus}
      />
    </StyledListAppDetailHeader>
  );
};

export default Header;
